import type { GetNodeByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetObjectTypeByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetObjectTypeByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetObjectTypeByIdArgs = {
  id: string;
};

export const useGetObjectTypeById = createQueryHook<
  UseGetObjectTypeByIdArgs,
  GetNodeByIdResponseRow | null,
  GetObjectTypeByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.node.getObjectTypeById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ node: data }),
  graphqlDocument: GetObjectTypeByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
